import { Component, inject } from "@angular/core";
import { AppService } from "../app.service";
import { Router } from "@angular/router";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";

@Component({
  selector: "app-create-apikey",
  standalone: false,
  templateUrl: "./create-apikey.component.html",
  styleUrls: ["./create-apikey.component.css"],
})
export class CreateApikeyComponent {
  createAPIKeyForm: FormGroup;
  downloadKeyForm: FormGroup;
  selectPlanForm: FormGroup;
  // apikeys: any;
  // apikey: any = {};

  apiKey: any;
  pbValue: any;
  workspaceName: any;
  txt: any;

  createNav = true;
  downloadNav = false;
  planNav = false;

  showInfoMsg: boolean = false;
  isLinear = false;
  uploadKeyControl = new FormControl("", [Validators.required]);
  identifierControl = new FormControl("", [Validators.required]);
  newWS = '';

  currentApiKey: string = "";
  currentWorkspaceName: string = "";
  hasSubmittedData: boolean = false;

  isEditable = false;

  constructor(
    public appService: AppService,
    public router: Router,
    private fb: FormBuilder
  ) {
    this.isEditable = true;
    this.isLinear = false;

    this.createAPIKeyForm = this.fb.group({
      name: ["", [Validators.required]],
      email: this.appService.get("xdbc.emailId"),
      institutionId: ["", [Validators.required]],
      institutionName: ["", [Validators.required]],
      routeType: "UI_SESSION"
    });
    this.downloadKeyForm = this.fb.group({});
    this.selectPlanForm = this.fb.group({});
  }

  ngOnInit(): void { }


  // async submit(){
  //   if (this.createAPIKeyForm.valid) {
  //   const formValues = this.createAPIKeyForm.value;
  //   let resp = await this.appService.postRequest(
  //     formValues,
  //     "auth/register"
  //   );
  //   if (resp?.message) {
  //       this.appService.addSuccessMessage(resp?.message);
  //       setTimeout(() => {
  //         this.router.navigate(["/workspace"]);
  //     }, 2000)
  //   } else {
  //     this.appService.addErrorMessage(resp?.message);
  //   }
  // }
  // }

  cancel() {
    this.router.navigate(["/workspace"]);
  }

  async submit() {

    if (this.createAPIKeyForm.valid) {
      try {
        const formValues = this.createAPIKeyForm.value;

        let registerResp = await this.appService.postRequest(
          formValues,
          "auth/register"
        );

        if (registerResp?.status !== "Success") {
          this.appService.addErrorMessage(
            registerResp?.message || "Registration failed"
          );
          return;
        }

        this.currentApiKey = registerResp.data.apiKey;
        this.currentWorkspaceName = registerResp.data.name;
        this.hasSubmittedData = true;

        this.apiKey = this.currentApiKey;
        this.workspaceName = this.currentWorkspaceName;

        //Generate Keypair
        const keyPair = await this.appService.getKeyPair();
        const publicKeyPEM = keyPair[0];
        const privateKeyPEM = keyPair[1];

        const submitKeyPayload = {
          apiKey: this.currentApiKey,
          publicKey: this.appService.convertPEMToBase64(publicKeyPEM),
        };

        let submitKeyResp = await this.appService.postRequest(
          submitKeyPayload,
          "auth/submit-key"
        );

        if (submitKeyResp?.status !== "Success") {
          this.appService.addErrorMessage(
            submitKeyResp?.message || "Key submission failed"
          );
          return;
        }

        await this.appService.storePrivateKeyInCryptoDB(
          privateKeyPEM,
          this.currentWorkspaceName,
          submitKeyResp?.data?.keyId
        );

        // Activate API
        await this.activateWorkspaceWithKey(
          this.currentApiKey,
          this.currentWorkspaceName
        );

        // Export pkey in file
        this.appService.addSuccessMessage(
          "Workspace created and activated successfully!"
        );


        setTimeout(() => {
          this.downloadFile(privateKeyPEM, this.currentWorkspaceName);
          this.createNav = false;
          this.downloadNav = true;
          this.appService.addSuccessMessage(
            "Privatekey downloaded successfully!"
          );
        }, 3000);
      } catch (error: any) {
        console.error("Error in submit:", error);
        this.appService.addErrorMessage(
          "Failed to create workspace: " + (error.message || "Unknown error")
        );
      }
    }
  }

  async activateWorkspaceWithKey(
    apiKey: string,
    workspaceName: string
  ): Promise<void> {
    try {
      const activationPayload = {
        name: workspaceName,
        routeType: "UI_SESSION"
      };

      const signatureData = await this.appService.wssign(
        activationPayload,
        workspaceName
      );

      if (!signatureData) {
        throw new Error("Failed to sign activation payload");
      }

      const signature = new TextDecoder().decode(signatureData);

      const response = await this.appService.wsPostRequestWithHeaders(
        activationPayload,
        "auth/activate",
        apiKey,
        signature
      );
      if (response?.status !== "Success") {
        throw new Error(response?.message || "Activation failed");
      }
    } catch (error: any) {
      throw new Error(
        "Failed to activate workspace: " + (error.message || "Unknown error")
      );
    }
  }

  // Download private key
  downloadFile(pkeyStr: string, wpsName: string) {
    var a = window.document.createElement("a");
    a.href = window.URL.createObjectURL(
      new Blob([pkeyStr], { type: "text/plain" })
    );
    a.download = wpsName + "_privatekey.pem";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  async submitLLMKey() {
    try {
      const uploadedKey = this.uploadKeyControl.value;
      const identifierVal = this.identifierControl.value;
      if (!uploadedKey?.trim()) {
        return;
      }

      const payload = {
        apiKey: this.currentApiKey,
        key: uploadedKey,
        identifier: identifierVal,
        model: "gpt-4",
        routeType: "UI_SESSION"
      };

      const signatureData = await this.appService.wssign(
        payload,
        this.workspaceName
      );

      if (!signatureData) {
        throw new Error("Failed to sign activation payload");
      }

      const signature = new TextDecoder().decode(signatureData);
      const response = await this.appService.wsPostRequestWithHeaders(
        payload,
        "user/register-llm",
        this.apiKey,
        signature
      );

      console.log('submitLLMKey3');

      // console.log(response.status,'response');
      // if(response?.status === ''){

      // }

      if (response && response?.status === "Success") {
        console.log('submitLLMKey4');
        this.appService.addSuccessMessage("key submitted successfully.");
        this.uploadKeyControl.reset();
        this.planNav = true;
        this.createNav = false;
        this.downloadNav = false;
      } else {
        this.uploadKeyControl.reset();
        throw new Error(response?.message);
      }
    } catch (error: any) {
      // this.appService.addErrorMessage("API key is invalid or expired");
      this.planNav = false;
      this.createNav = false;
      this.downloadNav = true;
      console.error("Error in key:", error);
    }
  }

  async selectPlan(plan: string) {
    try {
      if (this.currentApiKey && this.currentWorkspaceName) {
        this.apiKey = this.currentApiKey;
        this.workspaceName = this.currentWorkspaceName;
      } else {
        const wsJson = this.appService.get("xdbc.workspace");
        if (wsJson !== undefined && typeof wsJson === 'string' && wsJson.trim() !== '' && wsJson !== 'undefined') {
          try {
            const ws = JSON.parse(wsJson);
            this.apiKey = ws.apiKey;
            this.workspaceName = ws.workspaceName;
          } catch (err) {
            console.error('Invalid JSON:', err);
          }
        }
      }

      const activationPayload = {
        email: this.appService.get('xdbc.emailId'),
        tier: plan,
        routeType: "UI_SESSION"
      };

      const signatureData = await this.appService.wssign(
        activationPayload,
        this.workspaceName
      );

      if (!signatureData) {
        throw new Error("Failed to sign activation payload");
      }

      const signature = new TextDecoder().decode(signatureData);

      if (plan == 'pro') {

        const response = await this.appService.wsPostRequestWithHeaders(
          activationPayload,
          "usage/initiate-checkout",
          this.apiKey,
          signature
        );

        if (response.data.checkout_url) {
          window.location.href = response.data.checkout_url;
        }

      } else {
        const response = await this.appService.wsPostRequestWithHeaders(
          activationPayload,
          "usage/setup",
          this.apiKey,
          signature
        );

        this.pbValue = 100;
        if (response && response.status == "Success") {
          this.txt = response.message;
          this.appService.addSuccessMessage(this.txt);
          setTimeout(() => {
            this.router.navigate(["/workspace"]);
          }, 2000);

          //  window.location.reload();
        } else {
          throw new Error(response?.message);
        }

      }



    } catch (error: any) {
      console.error("Error in submitPrivateKey:", error);
      this.txt = "Activation failed: " + (error.message || "Unknown error");
      this.appService.addErrorMessage(
        "Failed to activate connector: " + (error.message || "Unknown error")
      );
    }
  }
}
